import React, {useContext} from 'react'
import styled from 'styled-components'
import {CustomerUploadManager, UploadForm} from '@modifi/plugin-documents'
import {useRenderPersistedObject} from '@modifi/plugin-onboarding'
import DocumentTypeActionsCol from './components/DocumentTypeActionsCol'
import ExistingFilesList from './components/existing-files-list'
import FileQueueEntry from './components/FileQueueEntry'
import DocumentTypeRow from './components/CustomDocumentTypeRow'

import {DocActionContext} from './context'
import FileUploadContainer from './components/FileUploadContainer'
import DocumentHeader from './components/DocumentHeader'

const UploadWrapper = styled.div`
  h6 {
    margin-left: 0;
  }
`

export const companyDocumentUploadComponents = {
  documentTypeActionsCol: DocumentTypeActionsCol,
  fileUploadContainer: FileUploadContainer,
  existingFilesList: ExistingFilesList,
  fileQueueEntry: FileQueueEntry,
  documentHeader: DocumentHeader,
  // documentTypeRow: DocumentTypeRow,
}

// @todo enforce UploadForm properties once they are exposed
type CompanyDocumentUploadProps = {
  multiple?: boolean
  displayDocumentType?: boolean
  components?: Record<string, React.ElementType | null> | null
} & Record<string, any>

const CompanyDocumentUpload: React.FC<CompanyDocumentUploadProps> = ({
  multiple = false,
  displayDocumentType = false,
  components = null,
  ...restProps
}) => {
  const mergedComponents = useRenderPersistedObject({
    ...companyDocumentUploadComponents,
    ...components,
    ...(displayDocumentType ? {} : {documentTypeRow: DocumentTypeRow}),
  })

  const {isReadOnly, useValidationFromContext} = useContext(DocActionContext)
  const isDisabled = () => isReadOnly

  return (
    <CustomerUploadManager>
      <UploadWrapper>
        <UploadForm
          // @ts-expect-error multiple not typed correctly
          multiple={multiple}
          components={mergedComponents}
          displayDocumentTypeLabel={displayDocumentType}
          {...restProps}
          {...(useValidationFromContext ? {isDisabled} : {})}
        />
      </UploadWrapper>
    </CustomerUploadManager>
  )
}

export default CompanyDocumentUpload
